import type { EntityConfig } from '../types'

export const orderEntity: EntityConfig = {
  id: 'order',
  displayName: 'Order',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'pending', label: 'Pending' },
      { value: 'processing', label: 'Processing' },
      { value: 'completed', label: 'Completed' },
      { value: 'cancelled', label: 'Cancelled' },
      { value: 'failed', label: 'Failed' },
    ],
    options: [
      { value: 'pending', label: 'Pending', color: 'pending' },
      { value: 'processing', label: 'Processing', color: 'pending' },
      { value: 'completed', label: 'Completed', color: 'success' },
      { value: 'cancelled', label: 'Cancelled', color: 'error' },
      { value: 'failed', label: 'Failed', color: 'error' },
    ],
    mappings: {
      all: ['pending', 'processing', 'completed', 'cancelled', 'failed'],
      pending: ['pending'],
      processing: ['processing'],
      completed: ['completed'],
      cancelled: ['cancelled'],
      failed: ['failed'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    amount: { type: 'amount', urlKey: 'amount' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
    'amount',
  ]
}
